"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class QuestionnaireToValidationMappingTransformer {
    /**
     * @inheritDoc
     */
    to(questionnaires) {
        const validationMapping = {};
        questionnaires.forEach((qestr) => {
            qestr.getQuestions().forEach((question) => {
                let type = null;
                if ((question.isTextInput() || question.isSingleSelect())) {
                    if (question.isValueTypeNumber()) {
                        type = "number";
                    }
                    else if (question.isValueTypeString()) {
                        type = "string";
                    }
                    else if (question.isValueTypeBoolean()) {
                        type = "boolean";
                    }
                    else if (question.isValueTypeDate()) {
                        type = "date";
                    }
                }
                else if (question.isMultipleSelect()) {
                    type = "array";
                }
                if (type === null) {
                    throw new WidgetError_1.default(`Unhandled validation mapping for questionnaire type '${question.getType()}'.`);
                }
                const mapping = {
                    type: type,
                    required: question.isRequired(),
                };
                const dependency = question.getDependency();
                if (dependency) {
                    mapping.validation_condition = (values) => {
                        // NOTE: We allow validation when the dependency field is undefined so that
                        // validation when in single field context can be done.
                        return values[dependency.field] === undefined ||
                            values[dependency.field] === dependency.value;
                    };
                }
                if (question.getInputMax() !== null) {
                    mapping.max = question.getInputMax();
                }
                if (question.getInputMin() !== null) {
                    mapping.min = question.getInputMin();
                }
                if (question.getInputRegex() !== null) {
                    mapping.regex = question.getInputRegex();
                }
                if (question.isMultipleSelect() && question.isRequired()) {
                    mapping.min = Math.max(mapping.min, 1);
                }
                validationMapping[question.getId()] = mapping;
            });
        });
        return {
            type: "object",
            value: validationMapping
        };
    }
    /**
     * @inheritDoc
     */
    from(data) {
        throw new WidgetError_1.default(`Creating questionnaire from validation data is not possible.`);
    }
}
exports.default = QuestionnaireToValidationMappingTransformer;
